import React from "react";
import "./Illustration.sass";

type IllustrationProps = {
  src: string;
  alt: string;
};

const Illustration = ({ src, alt }: IllustrationProps) => {
  return (
    <img src={src} className="illustration-image" alt={alt} />
  );
};

export default Illustration;
